// Town names from postcodes.io results, chosen to read like a place a business
// owner would recognise: "Huddersfield", not the council "Kirklees".
// Pure: works on postcodes.io results already fetched.
// The Worker (worker/index.js) keeps an exact copy of the block between the
// "shared" markers; workerCopies.test.js fails if the two drift apart.

// >>> shared: towns
// "Swindon (Swindon)" -> "Swindon". Empty -> null.
function cleanPlaceName(name) {
  const text = typeof name === "string" ? name.replace(/\s*\([^)]*\)\s*$/, "").trim() : "";
  return text || null;
}

// A full postcode ("HD3 3WE"), from its postcodes.io result: the built-up
// area ("Huddersfield"), else the parish for villages ("Great Shefford"),
// else the council.
function townOfPostcode(result) {
  if (!result) return null;
  const parish = typeof result.parish === "string" && !/unparished/i.test(result.parish) ? result.parish : null;
  return cleanPlaceName(result.bua) || cleanPlaceName(parish) || cleanPlaceName(result.admin_district);
}

// An outcode ("HD3"), from the full postcodes nearest its centre (nearest
// first) and, if known, its own list of councils: the built-up area most of
// the nearby postcodes in the same outcode are in (ties go to the nearest),
// else the council of the nearest postcode in it, else of the nearest
// postcode at all, else its first council.
function townOfOutcode(outcode, nearby, councils) {
  const list = Array.isArray(nearby) ? nearby.filter(Boolean) : [];
  const inside = list.filter(p => p.outcode === outcode);
  const counts = new Map();
  for (const p of inside) {
    const area = cleanPlaceName(p.bua);
    if (area) counts.set(area, (counts.get(area) || 0) + 1);
  }
  let best = null;
  for (const [area, count] of counts) if (!best || count > counts.get(best)) best = area;
  if (best) return best;
  return cleanPlaceName(inside[0]?.admin_district)
    || cleanPlaceName(list[0]?.admin_district)
    || cleanPlaceName(Array.isArray(councils) ? councils[0] : null);
}
// <<< shared: towns

export { cleanPlaceName, townOfPostcode, townOfOutcode };
